import React from "react"
import AudienceForm from "./audienceForm.js"
import ApiService from "../../../Services/ApiService";
import AlertService from "../../../Services/AlertService";

class Audience extends React.Component {
    state = {
        data: {},
        ranking: true,
        available_audiences: []
    };

    componentDidMount() {
        if (this.props.data) {
            if (this.props.data.campaignId) {
               this.fetchCampaign();
            }

            if (this.props.data.clientId) {
                this.fetchAudiences();
            }
        }
    }

    fetchCampaign = (resetAudienceID = false) => {
        const url = "/api/campaigns/fetch?campaign_id=" + this.props.data.campaignId;
        ApiService.get(url)
            .then(response => {
                let campaign = response.data.Campaign;
                if (campaign) {
                    this.setState({
                        data: campaign,
                    }, () => {
                        if (resetAudienceID) {
                            this.setState({data: {...this.state.data, audience_id: 0}});
                        }
                    });
                }
            })
            .catch(error => {
                console.log(error);
            })
    };

    fetchAudiences = () => {
        const url = "/api/clients/audiences?client_id=" + this.props.data.clientId;
        ApiService.get(url)
            .then(response => {
                let audiences = response.data.Audiences;
                this.setState({...this.state, available_audiences: audiences})
            })
    };

    handleFormChange(property, value) {
        this.setState({ data: { ...this.state.data, [property]: value } });
    }

    handleAudienceOptionChange = (e) => {
        const { name, value } = e.target;
        if (value > 0) {
            ApiService.get('/api/clients/audience/' + value)
            .then(response => {
                if (response.data.Success) {
                    let audience = response.data.Audience;
                    let jobFunctions = audience.job_functions;
                    let jobFunctionIDs = jobFunctions ? Object.keys(jobFunctions) : [];
                    jobFunctionIDs = jobFunctionIDs.map(id => parseInt(id));

                    this.setState({ data: { ...this.state.data, 
                        audience_id: value,
                        seniorities: audience.seniorities,
                        job_titles: audience.job_titles,
                        job_functions: jobFunctionIDs,
                        locations: audience.locations,
                        job_skills: audience.job_skills,
                        locale_id: audience.locale_id
                    }})

                }
            })
        } else {
            this.fetchCampaign(true);
        }

    };

    saveAudienceForm() {
        delete this.state.data['categories'];
        delete this.state.data['image_json_a'];
        delete this.state.data['image_json_b'];

        ApiService.post("/api/campaigns/update", this.state.data)
            .then(response => {
                if (response.data.Success) {
                    AlertService.success('Campaign saved successfully');
                } else {
                    AlertService.error('Oops! There was an error saving the Campaign');
                }
            })
            .catch(error => {
                AlertService.error('Oops! There was an error saving the Campaign');
            });
    }

    render() {

        let audienceOptions = null;

        if (this.state.available_audiences && this.state.available_audiences.length > 0) {
            audienceOptions = (
                <select value={this.state.data.audience_id} onChange={this.handleAudienceOptionChange}>
                    <option value={0}>(Select one)</option>
                     {this.state.available_audiences.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                </select>
            )
        }

        return (
            <div className="page-main">
                <div className="form-container">
                    <div className="accounts-audience">
                        <div>
                            {audienceOptions} 
                            <button className="btn-large" onClick={() => { window.open("/clients/audience?client_id=" + this.state.data.client_id) }}>Manage Audiences</button>
                        </div>
                        <br></br>
                        <div disabled={this.state.data.audience_id > 0}>
                        <AudienceForm campaignId={this.props.data.campaignId} data={this.state.data} ranking={this.state.ranking} onFormChange={this.handleFormChange.bind(this)} />
                        </div>
                    </div>
                    <hr width="1"></hr>
                    <div className="form-submit">
                        <button onClick={this.saveAudienceForm.bind(this)}>Save</button>
                        <button type="button" className="outline"
                            onClick={() => { this.props.history.push("/campaigns?client_id=" + this.state.data.client_id + "&client_name=" + this.state.data.client_name) }}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}



export default Audience